<template>
  <tab-content
    :title="tab.title"
    :icon="tab.icon"
    :before-change="tab.beforeChange"
  >
    <div
      v-for="component in tab.components"
      :key="component.component.name"
    >
      <component
        :is="component.component"
        :no-wrapper="true"
        :exclude="component.exclude"
        :active="active"
      />
    </div>
  </tab-content>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  tab: {
    type: Object,
    required: true,
  },
  activeTabIndex: {
    type: Number,
    default: 0,
  },
  index: {
    type: Number,
    default: 0,
  },
}

@Component
export default class BuilderWizardItem extends Vue.extend({ props }) {
  get active () {
    return this.index === this.activeTabIndex
  }
}

</script>
